export const getUserTaskEntryFrag = `
    id
    userTaskId
    parentId
    userId
    user {
        name
        surname
        titleBeforeName
        titleAfterName
        image
    }
    description
    createdAt
    updatedAt
`;

export const createTaskEntryFrag = `
    id
    userTaskId
    parentId
    userId
    user {
        name
        surname
        titleBeforeName
        titleAfterName
        image
    }
    description
    createdAt
    updatedAt
`;

export const updateTaskEntryFrag = `
    id
`;

export const getUserTaskAppointmentFrag = `
    id
    userTaskId
    date
    recurrenceRule
    completedAt
    createdAt
    updatedAt
`;

export const updateTaskAppointmentFrag = `
    id
`;
